import api from '../utils/api';
import { submitAndPollTextImprovement } from '../utils/pollTextImprovementJob';

export async function improveToneOfVoice({
  text,
  agentName,
  llmModelLineId,
  llmEffortId,
  userConsiderations,
}) {
  return submitAndPollTextImprovement(() =>
    api.post('/onboarding/improve-tone-of-voice', {
      text,
      agent_name: agentName || undefined,
      llm_model_line_id: llmModelLineId || undefined,
      llm_effort_id: llmEffortId || undefined,
      user_considerations: userConsiderations || undefined,
    })
  );
}

export async function improveSubAgentInstructions({
  text,
  subAgentType,
  agentName,
  executionPhase,
  llmModelLineId,
  llmEffortId,
  userConsiderations,
}) {
  return submitAndPollTextImprovement(() =>
    api.post('/onboarding/improve-sub-agent-instructions', {
      text,
      sub_agent_type: subAgentType,
      agent_name: agentName || undefined,
      execution_phase: executionPhase || undefined,
      llm_model_line_id: llmModelLineId || undefined,
      llm_effort_id: llmEffortId || undefined,
      user_considerations: userConsiderations || undefined,
    })
  );
}

export async function improveMcpUsageInstructions({
  text,
  mcpServerId,
  mcpServerLabel,
  mcpServerSlug,
  subAgentType,
  subAgentInstructions,
  agentName,
  executionPhase,
  llmModelLineId,
  llmEffortId,
  userConsiderations,
}) {
  return submitAndPollTextImprovement(() =>
    api.post('/onboarding/improve-mcp-usage-instructions', {
      text,
      mcp_server_id: mcpServerId,
      mcp_server_label: mcpServerLabel || undefined,
      mcp_server_slug: mcpServerSlug || undefined,
      sub_agent_type: subAgentType,
      sub_agent_instructions: subAgentInstructions || undefined,
      agent_name: agentName || undefined,
      execution_phase: executionPhase || undefined,
      llm_model_line_id: llmModelLineId || undefined,
      llm_effort_id: llmEffortId || undefined,
      user_considerations: userConsiderations || undefined,
    })
  );
}

export async function triageToneOfVoice({
  text,
  agentName,
  llmModelLineId,
  llmEffortId,
  userConsiderations,
}) {
  return submitAndPollTextImprovement(() =>
    api.post('/onboarding/triage-tone-of-voice', {
      text,
      agent_name: agentName || undefined,
      llm_model_line_id: llmModelLineId || undefined,
      llm_effort_id: llmEffortId || undefined,
      user_considerations: userConsiderations || undefined,
    })
  );
}

export async function triageSubAgentInstructions({
  text,
  subAgentType,
  agentName,
  executionPhase,
  llmModelLineId,
  llmEffortId,
  userConsiderations,
}) {
  return submitAndPollTextImprovement(() =>
    api.post('/onboarding/triage-sub-agent-instructions', {
      text,
      sub_agent_type: subAgentType,
      agent_name: agentName || undefined,
      execution_phase: executionPhase || undefined,
      llm_model_line_id: llmModelLineId || undefined,
      llm_effort_id: llmEffortId || undefined,
      user_considerations: userConsiderations || undefined,
    })
  );
}

export async function triageMcpUsageInstructions({
  text,
  mcpServerId,
  mcpServerLabel,
  mcpServerSlug,
  subAgentType,
  subAgentInstructions,
  agentName,
  executionPhase,
  llmModelLineId,
  llmEffortId,
  userConsiderations,
}) {
  return submitAndPollTextImprovement(() =>
    api.post('/onboarding/triage-mcp-usage-instructions', {
      text,
      mcp_server_id: mcpServerId,
      mcp_server_label: mcpServerLabel || undefined,
      mcp_server_slug: mcpServerSlug || undefined,
      sub_agent_type: subAgentType,
      sub_agent_instructions: subAgentInstructions || undefined,
      agent_name: agentName || undefined,
      execution_phase: executionPhase || undefined,
      llm_model_line_id: llmModelLineId || undefined,
      llm_effort_id: llmEffortId || undefined,
      user_considerations: userConsiderations || undefined,
    })
  );
}

export function mergeImproveConsiderations(considerations, answers = []) {
  const parts = [];
  if (considerations && considerations.trim()) {
    parts.push(considerations.trim());
  }

  const answerLines = (answers || [])
    .map((item) => {
      const prompt = (item?.prompt || '').trim();
      const answer = (item?.answer || '').trim();
      if (!answer) {
        return null;
      }
      return prompt ? `- ${prompt}: ${answer}` : `- ${answer}`;
    })
    .filter(Boolean);

  if (answerLines.length) {
    parts.push(`Respostas às perguntas de esclarecimento:\n${answerLines.join('\n')}`);
  }

  if (!parts.length) {
    return undefined;
  }
  return parts.join('\n\n');
}
